import { z } from "zod"
import { ResourceType } from "../api/generated"

export const RESOURCE_TYPE_COURSE = 10
export const RESOURCE_TYPE_LESSON = 20
export const RESOURCE_TYPE_COLLECTION = 30

export const RESOURCE_TYPE_LABELS: Record<number, ResourceType> = {
  [RESOURCE_TYPE_COURSE]: ResourceType.Course,
  [RESOURCE_TYPE_LESSON]: ResourceType.Lesson,
  [RESOURCE_TYPE_COLLECTION]: ResourceType.Collection
}

export const ResourceTypeSchema = z
  .union([
    z.literal(RESOURCE_TYPE_COURSE),
    z.literal(RESOURCE_TYPE_LESSON),
    z.literal(RESOURCE_TYPE_COLLECTION)
  ])
  .transform((resourceTypeInt, ctx) => {
    const resourceTypeEnum = RESOURCE_TYPE_LABELS[resourceTypeInt]

    if (!resourceTypeEnum) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Invalid resource type: ${resourceTypeInt}`
      })
      return z.NEVER
    }

    return resourceTypeEnum
  })
